export const MAX_DEPTH_LEVEL = 8
export const MAX_LENGTH_TILE = 256